var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationsBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 20.1997C8.25 20.1997 9.5 22.6997 12 22.6997C14.5 22.6997 15.75 20.1997 15.75 20.1997",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38889 8.81184C5.38889 5.16063 8.34878 2.19971 12 2.19971V2.19971C15.6512 2.19971 18.6111 5.16063 18.6111 8.81184C18.6111 10.2557 18.6111 11.5471 18.6111 12.1997C18.6111 14.1997 20.5 18.1997 20.5 18.1997H3.5C3.5 18.1997 5.38889 14.1997 5.38889 12.1997C5.38889 11.5471 5.38889 10.2557 5.38889 8.81184Z",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsBellIcon);
export default __webpack_public_path__ + "static/media/notifications-bell-icon.a0df7aea531991590c8f2543c0efdce2.svg";
export { ForwardRef as ReactComponent };